$(document).ready(customProduct);
document.addEventListener("ShoptetDOMPageContentLoaded", customProduct);
document.addEventListener("ShoptetPageSortingChanged", customProduct);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", customProduct);
document.addEventListener("ShoptetDOMContentLoaded", customProduct);

function customProduct() {
  const breadcrumbUrls = $('.breadcrumbs a[itemprop="item"]').map(function () {
    return $(this).attr('href');
}).get();

const vyloucenaUrl = vyloucenislevy.some(url =>
    breadcrumbUrls.includes(url)
);

  $(".product").each(function () {
    const $product = $(this);
    const $productPrices = $product.find(".prices").not(".ratings-wrapper .prices").first();
    if (!$product.find(".ratings-wrapper > .prices").length && $productPrices.length) {
      $product.find(".ratings-wrapper").append($productPrices.clone());
    }

    if ($product.find(".p-tools form").length) {
      if (!$product.find(".quantity").length) {
        $product.find(".p-tools form").prepend($quantity);
      }
    } else {
      $product.find(".p-tools a").text("Detail produktu");
    }
    const $priceSave = $product.find(".price-save");
    if ($priceSave.length) {
      if (!$product.find(".prices .price-standard").length) {
        $product.find(".prices").append($product.find(".flag-discount .price-standard").clone());
      }
    }

    const $productImage = $product.find("a.image").first();
    if ($productImage.length && !$productImage.children(".favorite").length) {
      const productId = $product.find('input[name="productId"]').val() || "";
      $productImage.append('<span class="favorite add-to-favorites" aria-label="Přidat do oblíbených" title="Přidat do oblíbených"></span>');
      $productImage.children(".favorite").attr("data-ids", JSON.stringify(productId ? [String(productId)] : []));
    }

    if (typeof getDeliveryDateByAvailability === "function" && typeof formatDeliveryDate === "function") {
      const availabilityText = $product.find(".availability > span:not(.availability-amount)").text().trim().toLowerCase();

      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (deliveryDate) {
        const formatted = formatDeliveryDate(deliveryDate);
        const $deliveryDate = $product.find(".deliveryDate");

        if ($deliveryDate.length) {
          $deliveryDate.text(`${formatted} u Vás`);
        } else {
          $product.find(".availability").append(`<div class="deliveryDate">${formatted} u Vás</div>`);
        }
      }
    }
   
if (
    !vyloucenaUrl &&
    Number(getShoptetDataLayer('customer').groupId) !== 8 &&
    $(this).find('.price-save').length === 0 &&
    $(this).find('.flag-discount-0').length === 0
) {
    const originalPriceText = $(this)
        .find('.p-bottom > div[data-micro="offer"]')
        .attr('data-micro-price');

    const discountedPrice =
        originalPriceText * (1 - slevaPoRegistraci / 100);

    const formattedDiscountedPrice =
        typeof discountedPrice.ShoptetFormatAsCurrency === "function"
            ? discountedPrice.ShoptetFormatAsCurrency()
            : discountedPrice;

    // Odstranění starého tooltipu a banneru
    $(this).find('.regBanner .show-tooltip').tooltip('destroy');
    $(this).find('.regBanner').remove();

    $(this).find('.p-bottom').prepend(`
        <div class="regBanner">
            <div class="text">
                <span class="tss"><i>${formattedDiscountedPrice}</i> ${textReg}</span>
                <span
                    class="show-tooltip question-tooltip"
                    title=""
                    data-original-title="${tooltipPoRegistraci}"
                >?</span>
            </div>
        </div>
    `);

    $(this).find('.regBanner .show-tooltip').tooltip({
        trigger: 'hover focus',
        container: 'body',
        placement: 'auto',
        html: true,
        delay: 0,
    });

} else {
    // Odstranění případného starého banneru
    $(this).find('.regBanner .show-tooltip').tooltip('destroy');
    $(this).find('.regBanner').remove();

    $(this).find('.p-bottom').prepend(
        '<div class="regBanner empty"></div>'
    );
}

// Dynamické sjednocení výšky bannerů
function syncRegBannerHeight() {
    const $firstBanner = $('.regBanner:not(.empty)').first();
    const $emptyBanners = $('.regBanner.empty');

    $emptyBanners.css('height', '');

    if (!$firstBanner.length) return;

    const bannerHeight = $firstBanner.outerHeight();

    $emptyBanners.outerHeight(bannerHeight);
}

// Přepočet po vykreslení bannerů
syncRegBannerHeight();

// Přepočet při změně velikosti okna
$(window)
    .off('resize.regBanner')
    .on('resize.regBanner', function () {
        syncRegBannerHeight();
    });

    $product.find(".availability").attr("style", $product.find(".availability>span").attr("style"));
  });
}

var $quantity = `
    <span class="quantity">
        <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMax" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMin" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <label>
            <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount">
        </label>
        <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
            <span class="increase__sign">+</span>
        </button>
        <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
            <span class="decrease__sign">−</span>
        </button>
    </span>
`;

$("html").on("click", ".products .product button.add-to-cart-button", function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var inputVal = $(this).closest(".p-tools").find("input").val();
  var inputPriceId = $(this).closest(".p-tools").find('input[name="priceId"]').attr("value");
  shoptet.cartShared.addToCart({ priceId: inputPriceId, amount: inputVal });
});
